import React from 'react';

import LeftArrow from '@material-ui/icons/ChevronLeftRounded';
import RightArrow from '@material-ui/icons/ChevronRightRounded';
import { navigate } from '@reach/router';

import Button from '../../../components/Button';

interface INavigatorItem {
  label: string;
  to: string;
}

interface IEventNavigator {
  previous: INavigatorItem;
  next?: INavigatorItem;
}

export const EventNavigator = (props: IEventNavigator) => {
  const {
    previous: { label: previousLabel, to: previousTo },
    next
  } = props;

  const goTo = (to: string) => () => navigate(to);

  return (
    <div className="event-navigator">
      <div className="previousContainer">
        <Button onClick={goTo(previousTo)} className="back-button override" variant="text">
          <LeftArrow className="left-arrow-icon" />
          {previousLabel}
        </Button>
      </div>

      <div className="nextContainer">
        {next && (
          <Button onClick={goTo(next.to)} className="back-button override" variant="text">
            {next.label}
            <RightArrow className="left-arrow-icon" />
          </Button>
        )}
      </div>
    </div>
  );
};
